import { Navigate } from "react-router-dom";
import { PAGES } from "../data/pages";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { CtaButton } from "../components/Buttons";
import { CtaBand } from "../components/CtaBand";
import { Stats } from "../components/home/Stats";
import { Press } from "../components/home/Press";
import { usePageMeta } from "../hooks/usePageMeta";

const Block = ({ b, i }) => (
  <Reveal delay={i * 0.08} className="border-t border-[color:var(--ngp-ink)] pt-6">
    <div data-testid={`page-block-${i + 1}`}>
      <p className="font-display text-sm text-[color:var(--ngp-muted)]">0{i + 1}</p>
      <h2 className="font-display mt-3 text-2xl font-semibold sm:text-3xl">{b.title}</h2>
      <ul className="mt-6 space-y-3">
        {b.points.map((p) => (
          <li key={p} className="flex gap-3 text-base leading-snug"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[color:var(--ngp-teal)]" aria-hidden="true" />{p}</li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export default function InnerPage({ slug }) {
  const page = PAGES[slug];
  usePageMeta(page?.metaTitle || "Nuova Giga Print", page?.metaDescription);
  if (!page) return <Navigate to="/" replace />;
  return (
    <>
      <PageHero eyebrow={page.eyebrow} title={page.title} img={page.img} alt={page.alt} />
      <section className="mx-auto max-w-[1440px] px-5 py-20 sm:px-8 lg:px-12 lg:py-32">
        <div className="grid gap-10 md:grid-cols-12">
          <Reveal className="md:col-span-8">
            <p data-testid="page-lead" className="font-display text-3xl font-medium leading-[1.15] sm:text-4xl lg:text-5xl">{page.lead}</p>
          </Reveal>
          <Reveal delay={0.15} className="flex md:col-span-4 md:items-end md:justify-end">
            <CtaButton to="/contatti" variant="dark" testId="page-quote-btn">Richiedi preventivo</CtaButton>
          </Reveal>
        </div>
        {page.blocks.length > 0 && (
          <div className="mt-20 grid gap-12 md:grid-cols-2 lg:grid-cols-3 lg:gap-10">
            {page.blocks.map((b, i) => <Block key={b.title} b={b} i={i} />)}
          </div>
        )}
      </section>
      {page.showStats && <Stats />}
      {page.showPress && <Press />}
      <CtaBand to="/contatti" />
    </>
  );
}
